import React, { Suspense } from 'react'

import { useTranslation } from 'react-i18next'
import { Await, useLoaderData, useNavigation } from 'react-router-dom'

import LoadingMessage from '@components/LoadingMessage'
import TemplateCopiesView from '@components/myScores/TemplateCopiesView'
import LoadingSpinner from '@components/shared/LoadingSpinner'
import { TemplateCopiesResponse, TemplateLoaderResponse } from '@pages/home/loaders/template.loader'
import { usePageTitle } from '@providers/LayoutProvider'

const TemplateCopiesPage: React.FC = () => {
  const { t } = useTranslation()
  const data = useLoaderData() as TemplateLoaderResponse
  const navigation = useNavigation()

  usePageTitle(t('titles.scoresFromTemplate'))

  const isReloading =
    navigation.state === 'loading' &&
    navigation.formData != null &&
    navigation.location.pathname.startsWith('/home/template/')

  return (
    <>
      {isReloading && <LoadingMessage />}
      <div className="flex-1 overflow-y-auto relative mr-7">
        <Suspense fallback={<LoadingSpinner />}>
          <Await resolve={data.templateCopies}>
            {(templateCopiesResp: TemplateCopiesResponse) => (
              <TemplateCopiesView initialData={templateCopiesResp} order={data.order} />
            )}
          </Await>
        </Suspense>
      </div>
    </>
  )
}

export default TemplateCopiesPage
